import { PathaoModel } from '@/http/models/courier/Pathao'
import { toast } from 'sonner'

import { useState } from 'react'

import { CourierModel } from '@/types/model/Courier'

export const usePathaoCourier = () => {
  const [loading, setLoading] = useState(false)
  const [stores, setStores] = useState<CourierModel.PathaoStore[]>([])
  const [cities, setCities] = useState<CourierModel.PathaoCity[]>([])
  const [zones, setZones] = useState<CourierModel.PathaoZone[]>([])
  const [areas, setAreas] = useState<CourierModel.PathaoArea[]>([])

  const fetchStores = async () => {
    const response = await PathaoModel.getStores()
    if (response.success && response.data?.result) {
      setStores(response.data.result)
    }
  }

  const fetchCities = async () => {
    setLoading(true)
    const response = await PathaoModel.getCities()
    if (response.success && response.data?.result) {
      setCities(response.data.result)
    }
    setLoading(false)
  }

  const fetchZones = async (cityId: string) => {
    setLoading(true)
    const response = await PathaoModel.getZones({ params: { cityId } })
    if (response.success && response.data?.result) {
      setZones(response.data.result)
    }
    setLoading(false)
  }

  const fetchAreas = async (zoneId: string) => {
    setLoading(true)
    const response = await PathaoModel.getAreas({ params: { zoneId } })
    if (response.success && response.data?.result) {
      setAreas(response.data.result)
    }
    setLoading(false)
  }

  const createParcel = async (payload: {
    order_id: string
    city_id: number
    zone_id: number
    area_id: number
  }) => {
    setLoading(true)
    try {
      const response = await PathaoModel.createParcel({
        body: payload,
      })

      if (response.success) {
        toast.success('Pathao parcel created successfully!')
        return response.data?.result
      } else {
        toast.error(response.error?.data?.message || 'Failed to create Pathao parcel')
        return null
      }
    } catch (error) {
      console.error('Pathao parcel creation error:', error)
      toast.error('An error occurred while creating Pathao parcel')
      return null
    } finally {
      setLoading(false)
    }
  }

  const trackParcel = async (orderId: string) => {
    setLoading(true)
    try {
      const response = await PathaoModel.trackParcel({
        body: { order_id: orderId },
      })

      if (response.success) {
        return response.data?.result
      } else {
        toast.error(response.error?.data?.message || 'Failed to track parcel')
        return null
      }
    } catch (error) {
      console.error('Pathao tracking error:', error)
      return null
    } finally {
      setLoading(false)
    }
  }

  const cancelParcel = async (orderId: string) => {
    setLoading(true)
    try {
      const response = await PathaoModel.cancelParcel({
        body: { order_id: orderId },
      })

      if (response.success) {
        toast.success('Pathao parcel cancelled successfully!')
        return response.data?.result
      } else {
        toast.error(response.error?.data?.message || 'Failed to cancel Pathao parcel')
        return null
      }
    } catch (error) {
      console.error('Pathao cancel error:', error)
      toast.error('An error occurred while cancelling parcel')
      return null
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    stores,
    cities,
    zones,
    areas,
    fetchStores,
    fetchCities,
    fetchZones,
    fetchAreas,
    createParcel,
    trackParcel,
    cancelParcel,
  }
}
